module.exports = __webpack_public_path__ + "static/media/view6.5e1e7183.jpg";